module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_tokushima-feec61755e2e615b0982f34a6b7ee34f.png";